module.exports = "<basler-list-item-selector\n    model=\"typekeyView.value\"\n    options=\"typekeyView.aspects.availableValues\"\n    track-by=\"option.code\"\n    option-name=\"option.name\"\n    disabled=\"disabled\"\n></basler-list-item-selector>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-list-item-selector-typekey.html
// module id = 554
// module chunks = 0